import React from 'react';
import { MembershipProposal } from '../pages/MembershipProposal';

export const membershipProposalRoutePage = {
  component: <MembershipProposal />,
  route: '/proposta-adesao',
};
